import { useState } from 'react'
import AddPropertyModal from '../components/AddPropertyModal'

import del from '../assets/icons/delete.svg'
import edit from '../assets/icons/edit.svg'

const Dashboar = () => {

  const [isOpen, setIsOpen] = useState(false);
  const emailStored = localStorage.getItem('akjodem_email');
  const loggedInStored = localStorage.getItem('akjodem_isLoggedIn');

  return (
    <>
      {loggedInStored ?
        <div className="bg-gray-100 min-h-screen">
          {/* Sidebar */}
          <aside className="fixed flex flex-col bg-blue-600 w-64 h-full text-white">
            <h2 className="p-4 border-b border-blue-500 font-bold text-xl">Dashboard</h2>
            <nav className="flex-grow">
              <ul>
                <li className="hover:bg-blue-500 p-4 cursor-pointer">Upload Properties</li>
                {/* Add more sidebar links as needed */}
              </ul>
              <ul>
                <li className="hover:bg-blue-500 p-4 cursor-pointer">Manage Properties</li>
                {/* Add more sidebar links as needed */}
              </ul>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="flex-grow ml-64 p-6">
            <h2 className="mb-6 font-semibold text-gray-800 text-2xl">Manage Properties</h2>
            <button onClick={() => setIsOpen(true)} className="bg-green-500 hover:bg-green-600 mr-2 px-3 py-1 rounded-lg text-white">
              Add Property
            </button>
            <div className="bg-white shadow-md p-4 rounded-lg overflow-x-auto">
              <table className="w-full table-auto">
                <thead>
                  <tr className="bg-gray-200 text-gray-700">
                    <th className="px-4 py-2 text-left">S/N</th>
                    <th className="px-4 py-2 text-left">Property Name</th>
                    <th className="px-4 py-2 text-left">Description</th>
                    <th className="px-4 py-2 text-left">Category</th>
                    <th className="px-4 py-2 text-left">Location</th>
                    <th className="px-4 py-2 text-left">Price</th>
                    <th className="px-4 py-2 text-left">Bedrooms</th>
                    <th className="px-4 py-2 text-left">Bathrooms</th>
                    <th className="px-4 py-2 text-left">Sqft</th>
                    <th className="px-4 py-2 text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Example Row */}
                  <tr className="hover:bg-gray-50 border-gray-200 border-b">
                    <td className="px-4 py-2">1</td>
                    <td className="px-4 py-2">Green Acres</td>
                    <td className="px-4 py-2">Beautiful countryside home</td>
                    <td className="px-4 py-2">Residential</td>
                    <td className="px-4 py-2">California</td>
                    <td className="px-4 py-2">$1,200,000</td>
                    <td className="px-4 py-2">3</td>
                    <td className="px-4 py-2">2</td>
                    <td className="px-4 py-2">1,800</td>
                    <td className="flex space-x-2 px-4 py-2">
                      <button className="bg-blue-500 hover:bg-blue-600 p-1 rounded-lg text-white">
                        <img src={edit} alt="edit icon" className="w-6" />
                      </button>
                      <button className="bg-red-500 hover:bg-red-600 p-1 rounded-lg text-white">
                        <img src={del} alt="delete icon" className="w-6" />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </main>

          {isOpen && <AddPropertyModal isOpen={isOpen} setIsOpen={setIsOpen} />}
        </div>
        : <h2>Redirecting to login...</h2>
      }
    </>
  )

}

export default Dashboar
